import { render, staticRenderFns } from "./BlankSlate.vue?vue&type=template&id=3570681f&scoped=true&"
import script from "./BlankSlate.vue?vue&type=script&lang=ts&"
export * from "./BlankSlate.vue?vue&type=script&lang=ts&"
import style0 from "./BlankSlate.vue?vue&type=style&index=0&id=3570681f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3570681f",
  null
  
)

export default component.exports